import type * as SsaiBundle from '@foundation-player/plugin-ssai';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { PluginConfig } from '../plugin-configs';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createSsaiPlugin: PluginFactoryFunction = (builderConfig) => {
  const packageName = PackageName.PluginSsai;

  return [
    [packageName],
    () => {
      const globalName = PACKAGE_NAME_TO_GLOBAL_NAME[packageName];
      const bundle = resolveByPackageNameOrThrow<typeof SsaiBundle>(packageName);
      const pluginConfig: PluginConfig<SsaiBundle.PluginConfig> | undefined = builderConfig.pluginConfigs[globalName];
      return [new bundle.SsaiPlugin(pluginConfig)];
    },
  ];
};
